import { RootState } from '../rootReducer'
import { createSelector } from 'reselect'
import { AuthState } from './auth.types'

export const authSelector = (state: RootState) => state.auth
export const isLoggedSelector = createSelector(authSelector, (state: AuthState) => state.user !== null)
export const userSelector = createSelector(authSelector, (state: AuthState) => state.user)
